export default "__VITE_ASSET__BSl5DsXe__"